// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__sqJnI","input":"styles_input__36YSu"};